import LocalizedStrings from 'react-localization';

let LN = new LocalizedStrings({
   
   
    fa: {
        required: "فیلد الزامیست",
        name: "سامانه نرم افزاری ",
      
    },
    en: {
        required: "Software system ",
        name: "Software system ",
        
    },

});
export default LN